import { useMemo } from "react";
import { useProtocolStore } from "@/hooks";
import { formatAPYDecimals } from "@/utils";
import { calculateStakeAPY } from "@/utils/apy";

interface UseStakingAPYResult {
    apy: string;
    isAPYLoading: boolean;
}

export function useStakingAPY(depositAmount = 0): UseStakingAPYResult {
    const { stats, farms, params, isLoading } = useProtocolStore();

    const apy = useMemo(() => {
        if (isLoading) return "";
        const apyValue = calculateStakeAPY(depositAmount, { stats, farms, params });
        const staked7d = stats.staked.average7dAPY;
        if (Number.isNaN(apyValue)) return "";
        return formatAPYDecimals(Math.max(apyValue, staked7d) * 100);
    }, [depositAmount, stats, farms, params, isLoading]);

    return {
        apy,
        isAPYLoading: isLoading,
    };
}
